import React from 'react';
import { ButtonSolid, ScreenContainer, withTheme } from '@draftbit/ui';
import { StyleSheet, Text, View } from 'react-native';

const WelcomeScreen = props => {
  const { theme } = props;
  const { navigation } = props;

  return (
    <ScreenContainer hasSafeArea={false} scrollable={false}>
      <View style={styles.View93bd7799}>
        <Text style={[styles.Text68f879fc, { color: theme.colors.strong }]}>
          {'Welcome!'}
        </Text>

        <Text style={[styles.Text14e32a55, { color: theme.colors.strong }]}>
          {"Let's first take a slow deep breath"}
        </Text>
        <ButtonSolid
          onPress={() => {
            try {
              navigation.navigate('HomeScreen');
            } catch (err) {
              console.error(err);
            }
          }}
          style={[
            styles.ButtonSolidc9f3878f,
            { backgroundColor: theme.colors.primary },
          ]}
          title={"I've slowed down"}
        />
      </View>
    </ScreenContainer>
  );
};

const styles = StyleSheet.create({
  Text68f879fc: {
    fontSize: 28,
    fontFamily: 'Roboto_400Regular',
  },
  Text14e32a55: {
    fontSize: 18,
    fontFamily: 'Roboto_400Regular',
    marginTop: 40,
  },
  ButtonSolidc9f3878f: {
    borderRadius: 8,
    fontFamily: 'System',
    fontWeight: '700',
    textAlign: 'center',
    marginTop: 50,
  },
  View93bd7799: {
    alignContent: 'center',
    alignItems: 'center',
    marginTop: 250,
  },
});

export default withTheme(WelcomeScreen);
